export const materialHeaders = [
  { id: 1, name: 'Material Code', tlabel: 'EXCEPTION_MATERIAL_CODE', col: 'material_code', width: 150 },
  { id: 8, name: 'Material Name', tlabel: 'EXCEPTION_MATERIAL_NAME', col: 'material_name', width: 150 },
  { id: 2, name: 'Source', tlabel: 'EXCEPTION_SOURCE', col: 'source', width: 140 },
  { id: 3, name: 'Destination', tlabel: 'EXCEPTION_DESTINATION', col: 'destination', width: 140 },
  { id: 4, name: 'Type', tlabel: 'EXCEPTION_TYPE', col: 'type', width: 140 },
];
export const materialHeaderDates = [
  { id: 5, name: 'Expected', tlabel: 'EXCEPTION_EXPECTED', col: 'expected', width: 140 },
  { id: 6, name: 'Actual', tlabel: 'EXCEPTION_ACTUAL', col: 'actual', width: 140 },
];
export const materialDeviationHeader = [
  { id: 7, name: 'Deviation', tlabel: 'EXCEPTION_DEVIATION', col: 'deviation', width: 150 },
];

export const truckHeaders = [
  { id: 1, name: 'Source', tlabel: 'EXCEPTION_SOURCE', col: 'source', width: 140 },
  { id: 2, name: 'Destination', tlabel: 'EXCEPTION_DESTINATION', col: 'destination', width: 140 },
  { id: 3, name: 'Type', tlabel: 'EXCEPTION_TYPE', col: 'type', width: 140 },
];

export const truckHeaderDates = [
  { id: 4, name: 'Expected', tlabel: 'EXCEPTION_EXPECTED', col: 'expected', width: 180 },
  { id: 5, name: 'Actual', tlabel: 'EXCEPTION_ACTUAL', col: 'actual', width: 180 },
];
export const truckDeviationHeader = [
  { id: 6, name: 'Deviation', tlabel: 'EXCEPTION_DEVIATION', col: 'deviation', width: 180 },
];
export const haltHeaders = [
  { id: 1, name: 'Start Time', tlabel: 'EXCEPTION_HALT_START', col: 'from_time', width: 200 },
  { id: 2, name: 'End Time', tlabel: 'EXCEPTION_HALT_END', col: 'to_time', width: 200 },
  { id: 3, name: 'Duration', tlabel: 'EXCEPTION_DURATION', col: 'duration', width: 200 },
];
export const EXCEPTION_TYPE = {
  INDENTS: 1,
  DELIVERIES: 2,
  VENDOR: 3,
  OPTIMA: 4,
  INEGRATION: 5,
};
export const totalItems = [
  { label: 'Indents', key: 1, value: 'INDENTS', columnMap: 'totalIndents' },
  { label: 'Deliveries', key: 2, value: 'DELIVERIES', columnMap: 'totalDeliveries' },
];
export const DeliveryItems = [
  { label: 'Vendor Owned', key: 2, value: 'VENDOR', columnMap: 'deliveries' },
];
export const indentFilters = [
  { label: 'Vendor Owned', key: 3, value: 'VENDOR', columnMap: 'direct_dispatch' },
  { label: 'Optima', key: 4, value: 'OPTIMA', columnMap: 'optima' },
];
export const allDates = [
  { name: 'Yesterday', id: 0 },
  { name: 'Today', id: 1 },
  { name: 'Tomorrow', id: 2 },
];

export const searchParameters = [
  { id: 1,
    name: 'source',
    query: 'source',
    tname: 'EXCEPTION_SOURCE',
    multiDropDownQueryOptions: [
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Source Ref id',
        tname: 'EXCEPTION_SOURCE_REF_ID',
        query: 'source_ref_id',
      },
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Source Name',
        tname: 'EXCEPTION_SOURCE_NAME',
        query: 'source_name',
      },
    ],
  },
  { id: 2, name: 'destination', query: 'destination_ref_id', tname: 'EXCEPTION_DESTINATION' },
  { id: 3, name: 'material invoice', query: 'material_num', tname: 'EXCEPTION_MATERIAL_INVOICE_NO' },
  { id: 4, name: 'indent number', query: 'indent_num', tname: 'EXCEPTION_INDENT_NUMBER' },
  { id: 5,
    name: 'material',
    query: 'material',
    tname: 'INDENT_MATERIAL',
    multiDropDownQueryOptions: [
      {
        label: 'in Code',
        tlabel: 'EXCEPTION_IN_MATERIAL_CODE',
        typeLabel: 'Code',
        ttypeLabel: 'INDENT_CODE',
        name: 'Material Code',
        tname: 'INDENT_MATERIAL_CODE',
        query: 'material_code',
      },
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Material Name',
        tname: 'EXCEPTION_MATERIAL_NAME',
        query: 'material_name',
      },
    ],
  },
];

export const IntegrationItem = [
  { label: 'Indents', key: 5, value: 'INEGRATION', columnMap: 'integrationEvents' },
];

export const integrationDetailsHeaders = [
  { id: 1, name: 'Error Reason', tlabel: 'INTEGRATION_ERROR_MESSAGE', col: 'error_message', width: 300 },
  { id: 2, name: 'Date | Time', tlabel: 'INTEGRATION_DATE', col: 'updated_at', width: 300 },
  { id: 3, name: 'Status', tlabel: 'INTEGRATION_STATUS', col: 'error_status', width: 300 },
];
